import axios from "axios";
import { baseURL } from "../config/index";
import api from "./apiURL";
import moment from "moment";

export async function getAdminAvailableDutyHCPs(visitID, dutyID) {
  try {
    const response = await api.get(
      `/api/v1/admin/duty/available-hcps?visitID=${visitID}&dutyID=${dutyID}`,
    );
    return response.data;
  } catch (error) {
    console.log(error);
    return {
      error: true,
      data: null,
      message: "Failed to load available staff",
    };
  }
}

export async function hcpChangeSubmit(data) {
  try {
    const response = await api.put(`/api/v1/admin/change/hcp`, data);
    return response.data;
  } catch (error) {
    console.log(error);
    return "Something went wrong";
  }
}

export async function adminDateSlotChange(data) {
  console.log(data);
  try {
    const response = await api.put(`/api/v1/admin/visit/reschedule/date`, data);
    return response.data;
  } catch (error) {
    console.log(error);
    return "Something went wrong";
  }
}

export async function adminTimeSlotChange(data) {
  try {
    const response = await api.put(`/api/v1/admin/visit/reschedule/time`, data);
    return response.data;
  } catch (error) {
    console.log(error);
    return "Something went wrong";
  }
}

export async function adminGetNurseRescheduleSlots(
  visitID,
  dutyID,
  startDate,
  serviceType,
) {
  console.log(serviceType, visitID, dutyID, startDate);
  try {
    const response = await api.get(
      `/api/v1/admin/hcp/slots/reschedule?for=self&role=nurse&service=${serviceType}&visitID=${visitID}&dutyID=${dutyID || ""}&startDate=${startDate}`,
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return "Something went wrong";
  }
}

export async function adminGetPhysioRescheduleSlots(
  visitID,
  dutyID,
  startDate,
) {
  try {
    const response = await api.get(
      `/api/v1/admin/hcp/slots/reschedule?for=self&role=physiotherapist&visitID=${visitID}&dutyID=${dutyID || ""}&startDate=${startDate}`,
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return "Something went wrong";
  }
}

export async function adminVisitForceClose(data) {
  try {
    const response = await api.put(`/api/v1/admin/visit/force-close`, data);
    return response.data;
  } catch (error) {
    console.log(error);
    return "Something went wrong";
  }
}

export async function uploadLabResult({ visitID, file }) {
  try {
    const formData = new FormData();
    formData.append("visitID", String(visitID || ""));
    formData.append("result", file);

    const response = await api.post(
      "/api/v1/visit/lab/result/upload",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response.data;
  } catch (error) {
    return (
      error?.response?.data || {
        error: true,
        message: "Unable to upload the lab result.",
      }
    );
  }
}

export async function getLabResultUrlForAdmin(visitID) {
  try {
    const response = await api.get(
      `/api/v1/visit/lab/result/url?visitID=${encodeURIComponent(
        String(visitID || ""),
      )}`,
    );
    return response.data;
  } catch (error) {
    return (
      error?.response?.data || {
        error: true,
        message: "Unable to load the lab result.",
      }
    );
  }
}
